module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }), _c('a', {
    attrs: {
      "id": "page11"
    }
  }), _c('a', {
    attrs: {
      "id": "page12"
    }
  }), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  })])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "src": "Images/ch.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Thwack, thwack, thwack…")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I pull the impassive covers fully over my head. The sound continues unabated, as though perhaps willfully seeking me out behind the fissures in the French doors. I sift slowly, detachedly, through the vocabulary of sound I have gleaned in these first Cairo weeks until I find it, that particular thwacking, in the hands of a servant girl, her red scarf knotted—harshly and without regard to line or precision—at the back of a too-thin neck whose tendons are ruddy cords, alert, tensed with effort. The carpet that she flogs dangles in disgraced submission from the sixth-floor balcony across the street. Threads of burgundy, forest green and midnight blue cough up an embarrassed fog of gray-black dust.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("The sound causes me to consider the dust in our own flat. ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("Reluctantly, as though expecting a reprimand, I push the blanket away from my eyes and peer about. The wide vanity table’s glass overlay and the curlicued ornamentation of the heavy oak wardrobe are coated in patient layers of gray. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I should clean,")]), _vm._v(" I murmur aloud. But it is an empty observation, void of any real intent. The task is too sweeping, the walls are too tall, the randomly placed frames too many, the wood and tiles of the floor suddenly endless in span and number. And I am, for now, too content to dwell in marvel at the fantastical accumulations. I wriggle out from under the covers, pulling myself out of the deep indentation in the cotton mattress where once a corpulent body—perhaps a renter like me, perhaps the original occupant—slept. My feet graze the parquet floor tentatively, tapping about for a possible slipper, losing hope immediately as they recall it has been three days since the slippers were last seen.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A flood of mote-heavy light pours in from the balcony, beckoning. I dispense quickly with the ministrations of teeth and face in my grimy green bathroom, then ease into clarity with steaming water and a spoonful of freeze-dried Nescafé. I drift back to my room and wrestle open the French doors. A swell of sound surges over me, a wave of late-morning light washes over me; I breathe deeply.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("A glance confirms the reality of the girl and the tormented carpet. Perhaps my gaze is palpable, for she turns suddenly to regard me. Her scarf today is dark blue, not red, but it does not look any newer than the one I have seen each week since my arrival. Her eyes flick over my sleep-creased T-shirt and cut-off sweatpants. Her look alights on my face and our eyes hold. I have watched her unobserved before, but today she is not so swept away in the relentless rhythm of the rug beater. She pauses to observe me, curiosity swimming in wide, oval eyes ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("that hover over bladelike cheekbones. I smile, and she seems at first taken aback. Then a wide smile surfaces from some remote store, and her face is momentarily transformed. I, chilled by the fifth-floor breezes after the cocoon of my indented bed, am warmed.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Turning back to her work, she strikes the carpet a last few times and, satisfied that it is purged of its filth, she sets her plastic weapon aside. With a tenderness that seems absurd after the violence of the previous moments, she lifts the rug from off the balcony rail and holds it aloft to keep the fringes from brushing the balcony tiles.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She has barely closed the door behind her when an identical door, one floor below, swings cautiously open. A scarved head emerges, then I watch as a woman, not young, not old, maneuvers a massive set of hips halfway through the door only to pause warily on the threshold. Her complexion is light, her eyes wide-set. Her ears, lurking unseen behind the spray of paisleys on her scarf, seem to be straining for some hint of sound. Meaty fingers clasp the long handle of a yellow broom as her thick neck cranes over the side edge of the balcony; her eyes dart about for signs of movement. Satisfied that the servant will not reappear, the woman begins attacking her own balcony with the yellow broom. The area, besieged by the dust showered upon it from above, submits to a few moments of near-obscurity as the gray cloud settles. Lips moving furiously in inaudible indignation, the woman pulls a cloth out of nowhere and slides it across the dust-coated ropes of her balcony clothesline. Every once in a while, she scratches viciously at a spot on her expansive forearm; she is irritated by the itch, and appears willing to scrape the skin off altogether rather than allow it to further hinder her chores. She disappears as suddenly as she came.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I clutch my elbows and lean against my own balcony rail. Garden City is an older neighborhood, its architecture mostly French-inspired. Graceful accents adorn broad cement buildings and squat villas long since humbled by the assaults of dust and exhaust and remorseless time. The streets of Garden City curve, twisting and twining in upon themselves like snakes unleashed in a cage formed by Qasr al-"), _c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/c.jpg"
    }
  }), _vm._v("Ayni Street to the east, and to the west, the wide corniche that runs the length of the Nile. Trees with broad, heavy leaves make intermittent appearances along the streets, distracting the eye from the inevitable strewn trash and broken sidewalks. Ghosts of a golden age drift, spent and listless, along these streets. Old women in worn spectator pumps and persistent hairdos clutch bulging plastic shopping bags and frayed leather purses. Subdued, stooped men in ragged cardigans sit across from each other in the corner café; the chess pieces splayed out between them gather dust in the wait between turns. It is a neighborhood where the wealthy once reigned, a neighborhood of old money that seems both surprised at its own decay and bitter over "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/c.jpg"
    }
  }), _vm._v("Abd al-Nasir’s socialization programs, despite the passage of fifty years. Foreigners roam here and there, renters like me of archaic flats with startling quirks. Dark-skinned doormen, flush with the knowledge that they alone control the steady flow of Garden City’s currents, lounge on rough wooden benches in gelabiyyas and carefully wound headgear.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Woven thinly among the formerly rich is a groping, grim middle class pleased with the prestigious address, despite it being only an illusory comfort against the daily grind. On the very visible peripheries are the rooftop dwellers and roaming peddlers and the vegetable sellers, who stake out sections of the sidewalks. The families of the swaggering doormen huddle tightly in tiny rooms off once-ornate foyers.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Outside my kitchen door is an interior world in which I do not attempt to tread. Fat women weighed down by astounding head-loads navigate the rickety wooden staircases that meander up and down the building’s hollow core. I have seen other residents bellow out their kitchen doors, and small children materialize from rooftop shanties. A breath of a girl with a bandanna on her head and wide, bulging eyes. A barefoot boy in a Scooby-Doo T-shirt from which his scabby arms dangle like broken branches. They do errands for twenty-five-piaster tips.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/c.jpg"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Umaymah! Run get me a kilo of milk!")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Hasanayn! A box of Red Marlboros!")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The trashman appears thrice weekly, toting on his back an enormous, tightly braided basket. He collects the plastic sacks my roommate and I place on the landing. He knocks on the kitchen door once each month, mutters a greeting, and takes his wages—he asks only three pounds for his services, less than a dollar. His face is tarred with filth, his hands black, the nails cracked. His gelabiyya hangs from his thin frame in grime-streaked tatters. He is always barefoot, and the calluses on his soles are lined with blackened cracks that snake up to just below the anklebone. His feet resemble a dried riverbed; the undertow tugs at me as I watch him pad away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Our building straddles the block formed by the raging Qasr al-"), _c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/c.jpg"
    }
  }), _vm._v("Ayni Street and the milder Hasan Murad. Our bedrooms overlook Hasan Murad, but we are privy to views of Qasr al-"), _c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/c.jpg"
    }
  }), _vm._v("Ayni from the balcony off the dining room. It is here that Meg and I sit late into the night, sipping tea or whatever version of coffee we can produce; sometimes we are joined by other year-abroad students, fleeing the staid and supervised hostel.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("The balcony is wide with ornate cement moldings. We peer over its edge and between the thick railings to watch Cairo churn along beneath us. Qasr al-"), _c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/c.jpg"
    }
  }), _vm._v("Ayni by night is a pathway ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("with no visible end, alive with red taillights and yellow headlights. The yips of indignant horns sluice across our conversations, washing away whole clauses.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When traffic noises are at a minimum, we can hear the clatter from the café that anchors the building facing ours. The sounds of backgammon pieces being slammed into place on wooden boards resound throughout the neighborhood.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There is a constant flow of people along the uneven sidewalks. Sent out for some forgotten necessity from the grocery, kids in flip-flops and sweats clutch a few bills in their hands, knuckles white and features set in responsible concentration. Arm in arm, girls in precise white scarves press against the walls of buildings in the ongoing effort not to be brushed against as small clusters of young men, pressed and slicked-back, walk rapidly, their loud, hope-heavy laughter clinging to the hot night air.")])])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page18"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bee0999","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780765316578_ch01.vue
// module id = 72
// module chunks = 0